// extracted by mini-css-extract-plugin
module.exports = {"container":"new-students_container__3-kTu","listItem":"new-students_listItem__1yFz2","showMore":"new-students_showMore__3-3RV"};